import { atom, atomFamily } from 'recoil';

import { QueryStatus } from 'react-query';

import { GiftItemInfoData, GiftItemInfoListData } from './giftItemInfo.interface';

// 목록 조회
export const giftItemInfoListStatusAtom = atom<QueryStatus>({
  key: 'giftItemInfoListStatusAtom',
  default: 'idle',
});

export const giftItemInfoListDataAtom = atom<GiftItemInfoListData | null>({
  key: 'giftItemInfoListDataAtom',
  default: null,
});

// 단건 조회
export const giftItemInfoStatusAtomFamily = atomFamily<QueryStatus, string>({
  key: 'giftItemInfoStatusAtomFamily',
  default: 'idle',
});

export const giftItemInfoDataAtomFamily = atomFamily<GiftItemInfoData | null, string>({
  key: 'giftItemInfoDataAtomFamily',
  default: null,
});

// 목록 필터 상태 유지
export type GiftItemInfoSortType =
  | 'order'
  | 'name-asc'
  | 'name-desc'
  | 'price-asc'
  | 'price-desc'
  | 'latest'
  | 'oldest';
export type GiftItemInfoTypeFilter = 'all' | 'Delivery' | 'Coupon';
export type GiftItemInfoStatusFilter = 'all' | 'enabled' | 'disabled';
export type GiftItemInfoTaxFilter = 'all' | 'taxable' | 'taxFree';

export const giftItemInfoSearchQueryAtom = atom<string>({
  key: 'giftItemInfoSearchQueryAtom',
  default: '',
});

export const giftItemInfoTypeFilterAtom = atom<GiftItemInfoTypeFilter>({
  key: 'giftItemInfoTypeFilterAtom',
  default: 'all',
});

export const giftItemInfoStatusFilterAtom = atom<GiftItemInfoStatusFilter>({
  key: 'giftItemInfoStatusFilterAtom',
  default: 'all',
});

export const giftItemInfoBrandFilterAtom = atom<string>({
  key: 'giftItemInfoBrandFilterAtom',
  default: 'all',
});

export const giftItemInfoTaxFilterAtom = atom<GiftItemInfoTaxFilter>({
  key: 'giftItemInfoTaxFilterAtom',
  default: 'all',
});

export const giftItemInfoSortTypeAtom = atom<GiftItemInfoSortType>({
  key: 'giftItemInfoSortTypeAtom',
  default: 'order',
});
